import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ResortDetail, ResortImage, ResortImageFormat, ResortImageType, ResortInventory } from '../../models/presentation.model';
import { ResortComponent } from '../resort.component';
import { ImageService } from '../../services/image.service';
import { ResortImageExtension } from '../../models/browser.model';

@Component({
  selector: 'resort-collage-banner',
  templateUrl: './resort-collage-banner.component.html',
  styleUrls: ['./resort-collage-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResortCollageBannerComponent  {

  @Input()
  public resort: ResortDetail;
  @Input()
  public imageTypes: ResortImageType[];

  public get imagesWithoutFloorPlans(): ResortImage[]{
    const images = this.imageService.getImagesByType(this.resort.resortImageList.where(i => i.fileName.substr(4,1) != 'F').toArray(), this.imageTypes);
    let dedupedImages = new Array<ResortImage>();

    images.forEach( i => { 
      if(dedupedImages.where(d => d.fileName === i.fileName).count() === 0 ){
          dedupedImages.add(i);
      }
    });

    return dedupedImages.take(8).toArray();
  }
  constructor(private imageService: ImageService) {
    
   }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/resort-collage-banner/resort-collage-banner.component.ts